var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.952 30.0392H2.64808C2.32204 30.0392 2.00055 29.8994 1.75698 29.6358C1.51218 29.3708 1.36853 29.0036 1.36853 28.6133V2.20104C1.36853 1.81068 1.51218 1.44348 1.75698 1.17855C2.00054 0.914956 2.32204 0.775146 2.64808 0.775146H20.952C21.278 0.775146 21.5995 0.914955 21.8431 1.17855C22.0879 1.44348 22.2315 1.81068 22.2315 2.20104V28.6133C22.2315 29.0036 22.0879 29.3708 21.8431 29.6358C21.5995 29.8994 21.278 30.0392 20.952 30.0392Z",
    fill: "white",
    stroke: "#004B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64805 0.550255C2.24351 0.550255 1.85554 0.724174 1.56949 1.03375C1.28343 1.34333 1.12273 1.76321 1.12273 2.20102V28.6133C1.12273 29.0511 1.28343 29.471 1.56949 29.7805C1.85554 30.0901 2.24351 30.264 2.64805 30.264H20.9519C21.3565 30.264 21.7445 30.0901 22.0305 29.7805C22.3166 29.471 22.4773 29.0511 22.4773 28.6133V2.20102C22.4773 1.76321 22.3166 1.34333 22.0305 1.03375C21.7445 0.724174 21.3565 0.550255 20.9519 0.550255H2.64805ZM2.64805 0H20.9519C21.4913 0 22.0086 0.231893 22.39 0.644664C22.7714 1.05744 22.9857 1.61727 22.9857 2.20102V28.6133C22.9857 29.197 22.7714 29.7569 22.39 30.1696C22.0086 30.5824 21.4913 30.8143 20.9519 30.8143H2.64805C2.10867 30.8143 1.59137 30.5824 1.20996 30.1696C0.82856 29.7569 0.614288 29.197 0.614288 28.6133V2.20102C0.614288 1.61727 0.82856 1.05744 1.20996 0.644664C1.59137 0.231893 2.10867 0 2.64805 0V0Z",
    fill: "#004B63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10431 21L19.5925 21",
    stroke: "#004B63",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10431 17L19.5925 17",
    stroke: "#004B63",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10431 13L19.5925 13",
    stroke: "#004B63",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8484 9H19.5925",
    stroke: "#004B63",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10431 25L19.5925 25",
    stroke: "#004B63",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.63629,
    y: 4.5,
    width: 4.80807,
    height: 5,
    stroke: "#004B63"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7726 24.5C28.7726 30.0383 24.4306 34.5 19.1085 34.5C13.7863 34.5 9.44437 30.0383 9.44437 24.5C9.44437 18.9617 13.7863 14.5 19.1085 14.5C24.4306 14.5 28.7726 18.9617 28.7726 24.5Z",
    fill: "white",
    stroke: "#004B63"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3266 20.4614V25.3076H23.0178",
    stroke: "#004B63",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.55115fd910cf1516484a4be6b0f8453c.svg";
export { ForwardRef as ReactComponent };